<template>
  <ul
    data-testid="app-menu"
    class="emd-menu-sidebar"
  >
    <li
      v-for="(section, key) in menu"
      :key="key"
      :id="key"
      class="emd-menu-sidebar__section"
      :class="{ _active: section.isActive, _open: openSection === key }"
      :data-testid="`sidemenu-section-${key}`"
    >
      <component
        :is="section.to ? 'router-link' : 'a'"
        :href="section.href || 'javascript:void(0);'"
        :to="section.to"
        class="emd-menu-sidebar__link"
        @click="setOpenSection(key)"
        :data-testid="`sidemenu-link-${key}`">
        <span class="emd-menu-sidebar__label">{{ section.label }}</span>
        <div
          v-if="section.children"
          class="emd-menu-sidebar__arrow">
          <i class="uil uil-angle-right"></i>
        </div>
      </component>
      <div
        v-if="section.children"
        class="emd-menu-sidebar__subsection"
      >
        <ul class="emd-menu-list">
          <li
            v-for="(item, key) in section.children"
            class="emd-menu-list__item"
            :class="{ _active: item.isActive }"
            :key="key"
          >
            <component
              :is="item.to ? 'router-link' : 'a'"
              :href="item.href || 'javascript:void(0);'"
              :to="item.to"
              :data-testid="`sidemenu-submenu-link-${key}`"
              :key="key"
            >{{ item.label }}</component>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'EmdMenuSidebar',
  props: {
    menu: {
      type: Object,
      required: true
    },
    routeActive: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      openSection: ''
    }
  },
  methods: {
    setOpenSection (key) {
      this.openSection = this.openSection === key ? '' : key
    },
    findSectionOpen (object, key) {
      for (const [index, section] of Object.entries(object)) {
        if (section.children) {
          const findActive = Object.keys(section.children).some(subSection => subSection === key)
          if (findActive) {
            return index
          }
        }

        if (index === key) {
          return index
        }
      }
      return ''
    }
  },
  created () {
    this.openSection = this.findSectionOpen(this.menu, this.routeActive)
  }
}
</script>
